import { connect } from 'react-redux';
import SiteRepositoryFinance from "./SiteRepositories";
import { bindActionCreators } from 'redux';
import {
    siteRepository,
    getSiteRepository,
    getSiteRepositoryFianance
} from 'services/redux/installation/siteListing/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    getSiteRepositoryDetails: state.siteListingReducer.siteRepository,
    createSiteRepository: state.siteListingReducer.createSiteRepository,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            siteRepository,
            getSiteRepository,
            getSiteRepositoryFianance
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SiteRepositoryFinance);
